import moment from "moment-timezone";

export default {
  name: "formatDateLocal",
  fn: (utcDateString, format) => {
    let timezone = moment.tz.guess();
    return utcDateString && utcDateString.length > 0 ? moment.tz(utcDateString, timezone).format(format) : "";
  }
};
